import { useState } from "react";
import { Websites } from "@components/quick_apply/websites.tsx";
import ModalFooter from "./modal_footer.tsx";
import useSectionSave from "./use_section_save.ts";
import type { SectionProps } from "./types.ts";

const OnlineProfilesSection = ({ data, onClose, source }: SectionProps) => {
  const { save, saving } = useSectionSave();
  const [websites, setWebsites] = useState(data.websites || {});

  const handleSave = async () => {
    const formData = new FormData();
    formData.append("websites[linkedin]", websites.linkedin || "");
    formData.append("websites[github]", websites.github || "");
    formData.append("websites[portfolio]", websites.portfolio || "");
    formData.append("websites[website]", websites.website || "");

    const success = await save(formData);
    if (success) onClose();
    return success;
  };

  return (
    <>
      <Websites websites={websites} setWebsites={setWebsites} />
      <ModalFooter
        section="online_profiles"
        onSave={handleSave}
        onCancel={onClose}
        saving={saving}
        source={source}
      />
    </>
  );
};

export default OnlineProfilesSection;
